/* lbn-delivery-week.js (2026-10-10, PREVIEW 188822880562): CNY delivery-week picker in the cart drawer.
   The pick is written to every CNY line as `Delivery week` (label, shown at checkout and on the order) and
   `_lbn_slot` (slot date, read by the LBN Shipping App). Open weeks come from the app's public /batches route.
   Debug: ?lbn_week_picker_test=1 (remembered; =0 forgets) also treats lines tagged Frozen as eligible.
   Clearing: /cart/change.js ignores `properties: {}` (measured 10 Oct), so a line with no other properties is
   cleared by setting both keys to null; null and "" count as no pick here, at checkout and in the Shipping App.
   A saved week that leaves a non-empty open list is cleared from every CNY line (Carl, 10 Oct, option B) and the
   note stays until the shopper picks again or closes the drawer. An empty or failed list clears nothing.
   Checkout guard (Carl, 10 Oct): while the cart has a CNY line, the open list has a week and no CNY line holds an
   open week, the drawer's checkout is locked through lbf-cart-page.js's LBF_CHECKOUT_GUARDS. No list or a failed
   fetch never blocks checkout (fail open).
   Ship now (Carl, 23 Oct): the list also offers "Ship within 3 working days". That pick writes only the label, with
   no `_lbn_slot`, so checkout offers the normal ship-now rate and the app counts no closed week. Shopper text goes
   through lbnT (en + zh); a zh page shows each week from its dates. The label saved on the line stays English. */
(function () {
  if (window.__lbnDeliveryWeek) return;
  window.__lbnDeliveryWeek = true;

  var API = 'https://lbf-shipping-rates.lbf-shipping-rates.workers.dev/batches?group=seasonal';
  var LABEL = 'Delivery week', SLOT = '_lbn_slot', FLAG = 'lbn_week_picker_test';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function t(key, fallback) { return window.lbnT ? window.lbnT(key, fallback) : fallback; }
  var NOTE_CLOSED = t('ship.dw_closed', 'That week is now full or closed. Please pick another.');
  var NOTE_FAILED = t('ship.dw_failed', 'We could not save your week. Please try again.');
  var GUARD_TEXT = t('ship.dw_guard', 'Pick your delivery week to check out.');
  var ASAP = { slot: 'asap', label: 'Ship within 3 working days' };
  var ZH = /^zh/i.test(document.documentElement.lang || '');
  var MONTH = /^\d{4}-(\d{2})-(\d{2})$/;
  /* What the shopper reads for an option; zh pages build "第A批：12月14–18日" from the week's dates */
  function shown(b) {
    if (b === ASAP) return t('ship.dw_asap', ASAP.label);
    var f = MONTH.exec(b.from || ''), e = MONTH.exec(b.to || '');
    if (!ZH || !f || !e) return b.label;
    var letter = /^Batch ([A-Z]):/.exec(b.label);
    var fm = +f[1], fd = +f[2], em = +e[1], ed = +e[2];
    var range = fm === em ? fm + '月' + fd + '–' + ed + '日' : fm + '月' + fd + '日–' + em + '月' + ed + '日';
    return (letter ? '第' + letter[1] + '批：' : '') + range;
  }

  var test = (function () {
    var m = location.search.match(new RegExp('[?&]' + FLAG + '=([01])'));
    try {
      if (m) { if (m[1] === '1') localStorage.setItem(FLAG, '1'); else localStorage.removeItem(FLAG); }
      return localStorage.getItem(FLAG) === '1';
    } catch (e) { return !!m && m[1] === '1'; }
  })();

  /* handle -> 'c' (cc_solo_ok / CNY Frozen), 'f' (Frozen), '' (neither); seeded by the snippet, then /products/x.js */
  var kinds = {}, asked = {};
  var batches = null; /* null: unknown or unavailable. []: none open. */
  var batchReq = null, batchTried = false;
  var want = null, writing = null, failed = false, closedNote = false;

  function block() { return document.querySelector('cart-drawer [data-lbn-dw]'); }
  function drawer() { return document.querySelector('cart-drawer'); }
  function kindFromTags(tags) {
    var t = (tags || []).map(function (x) { return String(x).trim().toLowerCase(); });
    if (t.indexOf('cc_solo_ok') !== -1 || t.indexOf('cny frozen') !== -1) return 'c';
    return t.indexOf('frozen') !== -1 ? 'f' : '';
  }
  function seed() {
    var b = block();
    if (!b) return;
    (b.getAttribute('data-lbn-dw-lines') || '').split(',').forEach(function (pair) {
      var p = pair.split(':');
      if (p.length === 2 && p[0]) kinds[p[0]] = p[1];
    });
  }
  function eligible(line) {
    var k = kinds[line.handle];
    return k === 'c' || (test && k === 'f');
  }
  function lookUp(cart) {
    var missing = (cart.items || []).map(function (l) { return l.handle; })
      .filter(function (h, i, a) { return h && a.indexOf(h) === i && !(h in kinds) && !asked[h]; });
    if (!missing.length) return Promise.resolve();
    return Promise.all(missing.map(function (h) {
      asked[h] = true;
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 404) { kinds[h] = ''; return; }
          if (!r.ok) throw new Error('product ' + r.status);
          return r.json().then(function (p) { kinds[h] = kindFromTags(p.tags); });
        })
        .catch(function () {}); /* asked again on the next drawer open, never on every cart update */
    }));
  }
  function cnyLines(cart) { return ((cart && cart.items) || []).filter(eligible); }

  function parseBatches(json) {
    var list = json && Array.isArray(json.batches) ? json.batches : null;
    if (!list) return null;
    return list.filter(function (b) {
      return b && /^\d{4}-\d{2}-\d{2}$/.test(b.slot) && typeof b.label === 'string' && b.label.trim();
    }).map(function (b) { return { slot: b.slot, label: b.label.trim(), from: b.deliverFrom, to: b.deliverTo }; });
  }
  /* XHR, not fetch: Shopify's analytics fetch wrapper turns a failed request into an unhandled rejection of its own,
     and a stuck request must give up quickly (no list = no block, checkout never waits on us). */
  function getJSON(url) {
    return new Promise(function (resolve) {
      var x = new XMLHttpRequest();
      x.open('GET', url + '&_=' + Date.now());
      x.timeout = 8000;
      x.onload = function () { try { resolve(x.status === 200 ? JSON.parse(x.responseText) : null); } catch (e) { resolve(null); } };
      x.onerror = x.ontimeout = function () { resolve(null); };
      x.send();
    });
  }
  function loadBatches() {
    if (batchReq) return batchReq;
    batchTried = true;
    batchReq = getJSON(API).then(parseBatches)
      .then(function (list) { batches = list; batchReq = null; paint(); reconcile(); });
    return batchReq;
  }

  function currentCart() {
    var c = window.LBF_CART && window.LBF_CART.get();
    if (c) return Promise.resolve(c);
    return readCart();
  }
  function readCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }

  var lastCart = null, guardWas = false;
  function isOpen(slot) { return !!slot && (batches || []).some(function (x) { return x.slot === slot; }); }
  function isAsap(line) { var p = line.properties || {}; return blank(p[SLOT]) && p[LABEL] === ASAP.label; }
  function guardOn() {
    var lines = cnyLines(lastCart);
    return !!(batches && batches.length && lines.length) &&
      !lines.some(function (l) { return isOpen(l.properties && l.properties[SLOT]) || isAsap(l); });
  }
  function focusSelect() {
    var sel = document.getElementById('lbn-dw-select');
    if (!sel) return;
    sel.scrollIntoView({ block: 'center' });
    sel.focus({ preventScroll: true });
  }
  (window.LBF_CHECKOUT_GUARDS = window.LBF_CHECKOUT_GUARDS || []).push(function () {
    return guardOn() ? { id: 'delivery-week', text: GUARD_TEXT, focus: focusSelect } : null;
  });
  /* a checkout submit that beats the footer repaint (server-rendered button) is held while the guard is on */
  document.addEventListener('submit', function (e) {
    var by = e.submitter;
    if (!guardOn() || !by || by.name !== 'checkout') return;
    e.preventDefault(); e.stopImmediatePropagation();
    focusSelect();
  }, true);
  function paint(cart) {
    if (cart) lastCart = cart;
    var on = guardOn();
    if (on !== guardWas) {
      guardWas = on;
      try { document.dispatchEvent(new CustomEvent('lbf:checkout-guard-change', { detail: { id: 'delivery-week', on: on } })); } catch (e) {}
    }
    var b = block();
    if (!b) return;
    var lines = cnyLines(lastCart);
    var show = !!(lines.length && batches && batches.length);
    b.hidden = !show;
    if (!show) return;
    var sel = b.querySelector('select'), note = b.querySelector('.lbn-dw__note');
    var sig = batches.map(function (x) { return x.slot + '|' + x.label; }).join('~');
    if (sel.getAttribute('data-sig') !== sig) {
      while (sel.options.length > 1) sel.remove(1);
      [ASAP].concat(batches).forEach(function (x) { sel.add(new Option(shown(x), x.slot)); });
      sel.setAttribute('data-sig', sig);
    }
    var saved = savedPick(lastCart);
    if (!writing) sel.value = saved.open ? saved.open.slot : '';
    var msg = failed ? NOTE_FAILED : (closedNote || (saved.slot && !saved.open) ? NOTE_CLOSED : '');
    note.textContent = msg;
    note.hidden = !msg;
    if (writing) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
  }

  function blank(v) { return v == null || v === ''; }
  function propsFor(line, pick) {
    var p = {};
    Object.keys(line.properties || {}).forEach(function (k) { if (k !== LABEL && k !== SLOT) p[k] = line.properties[k]; });
    if (pick) { p[LABEL] = pick.label; p[SLOT] = pick === ASAP ? null : pick.slot; }
    else if (!Object.keys(p).length) { p[LABEL] = null; p[SLOT] = null; }
    return p;
  }
  function settled(line, pick) {
    var p = line.properties || {};
    if (pick === ASAP) return isAsap(line);
    return pick ? p[SLOT] === pick.slot && p[LABEL] === pick.label : blank(p[SLOT]) && blank(p[LABEL]);
  }
  function savedPick(cart) {
    var slot = '', asap = false;
    cnyLines(cart).some(function (l) { slot = (l.properties && l.properties[SLOT]) || ''; asap = !slot && isAsap(l); return !!slot || asap; });
    if (asap) return { slot: ASAP.slot, open: ASAP };
    return { slot: slot, open: (batches || []).filter(function (x) { return x.slot === slot; })[0] || null };
  }
  /* wait for the theme's own cart queue (steppers write 350ms after the last tap) before reading line keys */
  function quietCart() {
    var q = window.LBF_CART && window.LBF_CART.whenSettled ? window.LBF_CART.whenSettled() : Promise.resolve();
    return q.then(readCart);
  }
  /* Converges every CNY line on the latest pick. Line keys change when properties change, so each pass works
     from the cart the previous write returned. Through window.fetch, so lbf-cart-journey.js refreshes the drawer. */
  function write() {
    if (writing) return writing;
    failed = false;
    var passes = 0;
    writing = quietCart().then(function step(cart) {
      var pick = want, todo = cnyLines(cart).filter(function (l) { return !settled(l, pick); });
      if (!todo.length) return cart;
      if (++passes > 2 * cnyLines(cart).length + 2) throw new Error('lines did not take the week');
      var line = todo[0];
      return window.fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: propsFor(line, pick) })
      }).then(function (r) {
        if (!r.ok) throw new Error('change ' + r.status);
        return quietCart();
      }).then(step);
    }).catch(function () {
      failed = true;
      return readCart().catch(function () { return lastCart; });
    }).then(function (cart) {
      writing = null;
      paint(cart);
      if (!failed && cnyLines(cart).some(function (l) { return !settled(l, want); })) write();
    }).catch(function () { writing = null; });
    return writing;
  }

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || sel.id !== 'lbn-dw-select' || !batches) return;
    want = sel.value === ASAP.slot ? ASAP : (batches.filter(function (x) { return x.slot === sel.value; })[0] || null);
    closedNote = false;
    write();
  });

  function refreshFrom(cart, fetchList) {
    lookUp(cart).then(function () {
      paint(cart);
      if (!cnyLines(cart).length) return;
      if (fetchList || !batchTried) loadBatches();
      reconcile();
    }).catch(function () {});
  }
  /* Brings the lines in line with the open list: a closed saved week is cleared from every CNY line, and a dish
     added after a pick (a new line without it) gets the saved week while that week is open. */
  function reconcile() {
    var cart = lastCart;
    if (!cart || writing || failed || !batches || !batches.length || !cnyLines(cart).length) return;
    var saved = savedPick(cart);
    if (saved.slot && !saved.open) {
      closedNote = true;
      want = null;
    } else if (saved.open && cnyLines(cart).some(function (l) { return !settled(l, saved.open); })) {
      want = saved.open;
    } else return;
    paint();
    write();
  }
  function onOpen() {
    seed();
    Object.keys(asked).forEach(function (h) { if (!(h in kinds)) delete asked[h]; });
    currentCart().then(function (cart) { refreshFrom(cart, true); }).catch(function () {});
  }
  function watchDrawer() {
    var d = drawer();
    if (!d || !window.MutationObserver) return;
    var was = d.classList.contains('active');
    new MutationObserver(function () {
      var now = d.classList.contains('active');
      if (now && !was) onOpen();
      if (!now && was && closedNote) { closedNote = false; paint(); }
      was = now;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }
  function init() {
    if (!drawer()) return;
    seed();
    watchDrawer();
    /* the drawer's keyed refresh can swap the whole scroll area (empty <-> non-empty): re-seed and repaint */
    document.addEventListener('lbf:drawer-refreshed', function () { seed(); paint(); });
    if (window.LBF_CART && window.LBF_CART.on) window.LBF_CART.on(function (c) { refreshFrom(c, false); });
    else currentCart().then(function (c) { refreshFrom(c, false); }).catch(function () {});
  }
  /* This file can run before lbf-cart-journey.js (deferred scripts run in document order while readyState is
     'interactive'), so wait for DOMContentLoaded, when LBF_CART exists. */
  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
